import { IconContent } from '@icons';

export const housing: IconContent = {
    md: '<path fill-rule="evenodd" d="m12.3 2.6 8 7.5-.3.9h-1v9H5v-9H4l-.3-.9 8-7.5h.6Zm-.3 1L5.3 10h13.4L12 3.7ZM16 19v-6h-5v6H6v-8h12v8h-2Zm-4 0v-5h3v5h-3Z" clip-rule="evenodd"/>',
};
